import { Region } from '../Shared/Region';
import { EffectTypes } from '../../Enums/EffectTypes';
import { getTransformedRegion } from '../../Helpers/compositorUtils';
import { BaseEffect } from './BaseEffect';
import { type VisualCompElement } from '../../types';

export class TransformEffect extends BaseEffect {
    static type = EffectTypes.TRANSFORM;

    static getRegionOfDefinition(region: Region, compElement: VisualCompElement) {
        return new Region(
            Number.NEGATIVE_INFINITY,
            Number.NEGATIVE_INFINITY,
            Number.POSITIVE_INFINITY,
            Number.POSITIVE_INFINITY,
        );
    }

    // TODO: refactor this, since it is not using the region as an input
    static getRegionOfInterest(region: Region | null, compElement: VisualCompElement) {
        const transform = compElement.getAbsContentTransform(); // transformation relative to root canvas

        // use width and height of the content;
        const width = compElement.contentBox.dimension.width;
        const height = compElement.contentBox.dimension.height;

        return getTransformedRegion(transform, width, height);
    }
}
